import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};

import mtekLogo from "../../../assets/images/mtek-logo.svg";
import CurrencyFormatter from "../../shared/currency-formatter";

function BaggageClaim({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const b = sessionStorage.getItem("baggageItems")!
  const bggItems = JSON.parse(b)
  const [itemInfo, setItemInfo] = useState({
    name: "",
    purchaseDate: "",
    shopName: "",
    townName: "",
    itemPrice: 0,
    claimPrice: 0,
  });

  const [baggageItems, setBaggageItems] = useState<any[]>(bggItems ? bggItems : []);
  useEffect(() => {
    setCurrentScreen("baggage-claim");
    sessionStorage.setItem("claim-screens", "baggage-claim");
  });

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setItemInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const addItem = () => {
    if (!itemInfo.name) {
      toast.warning(t("baggageClaim.enterItemName"));
      document.getElementById("name")?.focus;
      return;
    }
    if (!itemInfo.purchaseDate) {
      toast.warning(t("baggageClaim.enterPurchaseDate"));
      document.getElementById("purchaseDate")?.focus;
      return;
    }
    if (!itemInfo.shopName) {
      toast.warning(t("baggageClaim.enterShopName"));
      document.getElementById("shopName")?.focus;
      return;
    }
    if (!itemInfo.townName) {
      toast.warning(t("baggageClaim.enterTownName"));
      document.getElementById("townName")?.focus;
      return;
    }
    if (!itemInfo.itemPrice) {
      toast.warning(t("baggageClaim.enterItemPrice"));
      document.getElementById("itemPrice")?.focus;
      return;
    }
    if (!itemInfo.claimPrice) {
      toast.warning(t("baggageClaim.enterClaimPrice"));
      document.getElementById("claimPrice")?.focus;
      return;
    }
    if (Array.isArray(baggageItems)) {
      setBaggageItems([...baggageItems, itemInfo as any]);
      setItemInfo({
        name: "",
        purchaseDate: "",
        shopName: "",
        townName: "",
        itemPrice: 0,
        claimPrice: 0,
      });
    } else {
      setBaggageItems([itemInfo as any]);
      setItemInfo({
        name: "",
        purchaseDate: "",
        shopName: "",
        townName: "",
        itemPrice: 0,
        claimPrice: 0,
      });
    }
  };

  const saveDetails = () => {
    if(baggageItems.length < 1){
      toast.warning(t("baggageClaim.addAtLeastOneItem"))
      return
    }
      sessionStorage.setItem('baggageItems', JSON.stringify(baggageItems))
      setCurrentScreen("baggage-claim-additional")
      sessionStorage.setItem('claim-screens', "baggage-claim-additional")
  };

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div
          className="image text-center mt-5 mb-3"
          onClick={() => navigate("/")}
        >
          <img src={mtekLogo} alt="travel icon" />
        </div>
        <div className="reg-title text-center mb-4">
          <span style={{ color: "#000000" }}>
            {t("baggageClaim.provideDetailsHeader")}
          </span>{" "}
          <span className="span-title">{t("baggageClaim.baggageClaim")}</span>  
        </div>
        <div className="cancellation-input">
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="name">
                  {t("baggageClaim.fullDetailsItem")}
                </label>
                <br />
                <input
                  id="name"
                  name="name"
                  type="text"
                  onChange={handleInputChange}
                  value={itemInfo.name}
                  placeholder={t("baggageClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="purchaseDate">
                  {t("baggageClaim.whenPurchased")}
                </label>
                <br />
                <input
                  id="purchaseDate"
                  name="purchaseDate"
                  type="date"
                  onChange={handleInputChange}
                  value={itemInfo.purchaseDate}
                ></input>
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="shopName">
                  {t("baggageClaim.wherePurchased")}
                </label>
                <br />
                <input
                  id="shopName"
                  name="shopName"
                  type="text"
                  onChange={handleInputChange}
                  value={itemInfo.shopName}
                  placeholder={t("baggageClaim.typeShopName")}
                ></input>
                <div className="town-name mt-2">
                  <input
                    id="townName"
                    name="townName"
                    type="text"
                    onChange={handleInputChange}
                    value={itemInfo.townName}
                    placeholder={t("baggageClaim.typeTownName")}
                  ></input>
                </div>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="itemPrice">
                  {t("baggageClaim.howMuchPrice")}
                </label>
                <br />
                <input
                  id="itemPrice"
                  name="itemPrice"
                  type="number"
                  onChange={handleInputChange}
                  value={itemInfo.itemPrice}
                  placeholder={t("baggageClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="claimPrice">
                  {t("baggageClaim.howMuchClaimed")}
                </label>
                <br />
                <input
                  id="claimPrice"
                  name="claimPrice"
                  type="number"
                  onChange={handleInputChange}
                  value={itemInfo.claimPrice}
                  placeholder={t("baggageClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
        </div>
        <hr />
        <div className="claim-options">
          {baggageItems.length > 0 &&
            baggageItems.map((item, index) => {
              return (
                <div className="baggage-item" key={index}>
                  <div className="item-name">{item.name}</div>
                  <div className="item-price">
                    {t("baggageClaim.priceLabel")}{" "}
                    <CurrencyFormatter
                      value={item.itemPrice}
                      displayType={"text"}
                    />
                  </div>
                  <div className="item-price">
                    {t("baggageClaim.amountClaimedLabel")}{" "}
                    <CurrencyFormatter
                      value={item.claimPrice}
                      displayType={"text"}
                    />
                  </div>
                </div>
              );
            })}
        </div>
        <div className="add-claim-item">
          <button className="btn-add-item" onClick={() => addItem()}>
            {t("baggageClaim.addAnotherItem")}
          </button>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div className="previous">
            <span
              onClick={(e) => {
                sessionStorage.setItem("claim-screens", "claim-options");
                setCurrentScreen("claim-options");
              }}
            >
              <span className="GrIcon me-2">
                <GrIcons.GrFormPreviousLink />
              </span>{" "}
              <span className="previous">{t("baggageClaim.previous")}</span>
            </span>
          </div>
          <div className="mt-5" onClick={() => saveDetails()}>
            <button className="pointer-btn next-btn">
              {" "}
              <span>
                {t("baggageClaim.proceed")}{" "}
                <span className="GrIcon ms-3">
                  <GrIcons.GrFormNextLink />
                </span>
              </span>{" "}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default BaggageClaim;
